import React from 'react';

export default function ActionCard({ title, desc, icon, darkMode, onClick, disabled = false }) {
  const activeBg = darkMode ? 'bg-gray-900/20 border-gray-800 hover:border-gray-700' : 'bg-white border-gray-200 hover:border-purple-100';
  const disabledBg = 'bg-sky-100 border-sky-200 text-sky-700 cursor-not-allowed opacity-80';

  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={`p-4 rounded-xl border flex items-center gap-4 transition-all ${disabled ? disabledBg : `cursor-pointer group ${activeBg}`}`}
    >
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition border ${disabled ? 'bg-sky-100 text-sky-700 border-sky-200' : 'bg-gray-900 text-purple-500/60 border-gray-800'}`}>
        {icon}
      </div>
      <div>
        <h4 className={`font-bold text-xs ${disabled ? 'text-sky-700' : darkMode ? 'text-white' : 'text-gray-900'}`}>{title}</h4>
        <p className={`text-[10px] mt-0.5 ${disabled ? 'text-sky-700/90' : 'text-gray-500'}`}>{desc}</p>
      </div>
    </div>
  );
}
